import { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MessageSquare } from "lucide-react";
import Loader from "../../../components/Loaders/Loader";
import { PRIMARY_COLOR } from "../../../utils/colors";
import {
  ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE,
  ANNOTATIONS_SIDEBAR_EMPTY_TITLE,
  ANNOTATIONS_SIDEBAR_LOADING,
} from "../../../i18n/keysTranslations";
import { buildAnnotationUserColorMap } from "../utils/annotationUserColors";
import AnnotationMessage from "./AnnotationMessage";

const AnnotationMessageList = ({
  messagesScrollRef,
  isAnnotationsLoading = false,
  hasNoAnnotations = false,
  allAnnotations = [],
  currentOwnerUid,
  ownersByID = {},
  t,
  onDownloadFile,
  onOpenFile,
  onOpenMessageMenu,
}) => {
  const userColorByID = useMemo(
    () =>
      buildAnnotationUserColorMap({
        annotations: allAnnotations,
        currentOwnerUid,
      }),
    [allAnnotations, currentOwnerUid]
  );

  return (
    <Box
      ref={messagesScrollRef}
      sx={{
        flex: 1,
        overflowY: "auto",
        px: 1.5,
        py: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      {isAnnotationsLoading ? (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Loader hasMarginTop={false} size={28} />
          <Typography variant="body2" color="text.secondary">
            {t(ANNOTATIONS_SIDEBAR_LOADING)}
          </Typography>
        </Box>
      ) : hasNoAnnotations ? (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            px: 2,
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mb: 0.5 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                bgcolor: PRIMARY_COLOR,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MessageSquare size={24} color="#ffffff" />
            </Box>
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t(ANNOTATIONS_SIDEBAR_EMPTY_TITLE)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE)}
          </Typography>
        </Box>
      ) : (
        allAnnotations.map((annotation) => (
          <AnnotationMessage
            key={annotation.annotationID}
            annotation={annotation}
            currentOwnerUid={currentOwnerUid}
            ownersByID={ownersByID}
            userColor={userColorByID[annotation.userID]}
            t={t}
            onDownloadFile={onDownloadFile}
            onOpenFile={onOpenFile}
            onOpenMessageMenu={onOpenMessageMenu}
          />
        ))
      )}
    </Box>
  );
};

export default AnnotationMessageList;
